var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SystemBaseForm',{attrs:{"value":_vm.data,"update":"","submitText":"Update"},on:{"submit":_vm.onUpdate,"cancel":_vm.onCancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }